/* tslint:disable */

/**
 * Inicializaión de la clase InternDeviceModel
 * 
 * *Set InternDeviceModel class*
 * 
 * @access public
 * @type {class}
 */
export class InternDeviceModel {
  /**
   * Identificación del dispositivo
   * 
   * *Device Id*
   * 
   * @type {string} device_id
   */
  device_id: string;

  /**
   * Versión del sistema operativo
   * 
   * *Device OS version*
   * 
   * @type {string} os_version
   */
  os_version: string;

  /**
   * Marca del dispositivo
   * 
   * *Device Brand*
   * 
   * @type {string} brand
   */
  brand: string;

  /**
   * Modelo del dispositivo
   * 
   * *Device Model'
   * 
   * @type {string} model
   */
  model: string;

  /**
   * Nombre del Evento
   * 
   * *Event Name*
   * 
   * @type {string} event_name
   */
  event_name?: string;

  /**
   * Dirección IP del dispositivo
   * 
   * *Device IP address*
   * 
   * @type {string} ip
   */
  ip?: string;
}

/**
 * Inicializaión de la clase InternTransactionModel
 * 
 * *Set InternTransactionModel class*
 * 
 * @access public
 * @type {class}
 */
export class InternTransactionModel {
  /**
   * 
   * @type {string} transaction_code
   */
  transaction_code?: string;

  /**
   * 
   * @type {string} transaction_type
   */
  transaction_type: string;

}


/**
 * Inicializaión de la interfaz IProductsModel como Object
 * 
 * *Set IProductsModel interface as Object*
 * 
 * @access public
 * @type {class}
 */
export class LogDeviceModel {
  /**
   * Inicializaión de la variable device como InternDeviceModel
   * 
   * *Set device variable as InternDeviceModel*
   * 
   * @access public
   */
  device: InternDeviceModel;

  /**
   * Inicializaión de la variable terms_type como string (no obligatoria)
   * 
   * *Set device terms_type as string (not mandatory)*
   * 
   * @access public
   */
  terms_type?: string;

  /**
   * Constructor de la clase  
   * *Class Contstructor.*
   * 
   * @var {InternDeviceModel} device  Sets as new InternDeviceModel
   * 
   */

  /**
   * Inicializaión de la variable device como InternTransactionModel
   * 
   * *Set device variable as InternTransactionModel*
   * 
   * @access public
   */
  transaction: InternTransactionModel;

  constructor() {
    this.device = new InternDeviceModel();
  }
}
